import { Link, useLocation } from 'react-router'
import { CenteredFrame } from '../components/AppFrame'

/**
 * Task 2.1e — the in-app 404.
 *
 * Cloudflare Pages returns index.html with HTTP 200 for every unmatched path,
 * so the SERVER cannot tell a rep that a URL is wrong; only the app can. Before
 * this screen existed an unmatched path rendered an empty document, which reads
 * as the orders page failing to load — the worse of the two failures, because
 * it sends the rep to support instead of to the address bar.
 *
 * Deliberately NOT behind RequireAuth. The URL does not exist whether or not
 * you are signed in, and it shows no data, so gating it would only mean a
 * mistyped link produced a sign-in prompt and then a 404.
 *
 * The path is echoed back because these arrive by mistyped or truncated deep
 * link — /sku/ABC123 clipped by a mail client, for instance — and seeing the
 * path is usually enough for the rep to spot it themselves.
 */
export function NotFoundScreen() {
  const location = useLocation()

  return (
    <CenteredFrame>
      <h1>Page Not Found</h1>
      <p className="esl-muted" style={{ marginTop: 'var(--esl-space-3)' }}>
        Nothing exists at this address. If you followed a link, it may have been cut short.
      </p>
      <p
        style={{
          marginTop: 'var(--esl-space-4)',
          padding: 'var(--esl-space-3)',
          background: 'var(--esl-surface-sunken)',
          border: '1px solid var(--esl-border)',
          borderRadius: 'var(--esl-radius)',
          fontFamily: 'var(--esl-font-mono)',
          fontSize: 'var(--esl-size-meta)',
          overflowWrap: 'anywhere',
        }}
      >
        {location.pathname}
      </p>
      <p style={{ marginTop: 'var(--esl-space-5)' }}>
        <Link to="/">Go to orders</Link>
      </p>
    </CenteredFrame>
  )
}
